'use strict';

import App from 'App';
import User from 'User';
import Server from 'server/Server';
import DomainManager from '../DomainManager';
import LoadingMask from 'views/loading/LoadingMask';

import { LoginRequest } from '../server/protocol/request/auth/LoginRequest';

import ThemeManager from '../parametrage/ThemeManager';

import * as moment from 'moment';
import * as Backbone from 'backbone';
let $ = require('jquery');
import { DomainContext } from '../parametrage/DomainContext';
import { SAIView } from '../Additions';
import CClientConfiguration from 'parametrage/CClientConfiguration';
import Config from 'Config';
import AlertManager from '../utils/notification/AlertManager';
import { PasswordUpdateRequest } from '../server/protocol/request/auth/PasswordUpdateRequest';
import ServerUtils from '../utils/ServerUtils';
import I18NUtils from '../utils/i18n/I18NUtils';
import MfaUtils, { MfaMessage } from '../utils/MfaUtils';

class Login extends SAIView {

    mainFrame : JQuery<HTMLElement>;
    background : JQuery<HTMLElement>;
    invalidLabel : JQuery<HTMLElement>;
    currentOrientation : any;
    loginPath : boolean;
    mfaChallenge : { code : string, screenId : string } | null = null;
    mfaRequestId = 0;
    pendingMfaResponse : 'VALIDATE' | 'RESEND' | null = null;
    originalLoginButtonLabel : string | undefined;

    constructor(options){
        super(options);
        this.tagName = 'div';
        this.template = require('templates/Login');
        this.id = '';
        this.className = 'loginPanel';
        Backbone.View.apply(this, arguments);
    }

    getViewType():string {
        return 'login';
    }

    events() : Backbone.EventsHash {
        return {
        //'click #loginBtn' : 'onClick',
        'resize' : 'onWindowResize'
        }
    }

    initialize(options) {
        App.checkAppVersion(true);
    }

    render () : any {
        this.$el.html(this.template({
            applogo: CClientConfiguration.getGlobalImage(CClientConfiguration.APP_LOGO_WHITE),
            window: window
        }));

        this.background = this.$el.find('.siteBackgroundImage');

        this.mainFrame = this.$el.find('.loginFormCont');

        this.mainFrame.bind('webkitAnimationEnd', function () {
            this.style.webkitAnimationName = '';
        });
        this.mainFrame.bind('animationEnd', function () {
            this.style.animationName = '';
        });

        this.invalidLabel = this.$el.find('.invaliduserpass');

        //VBH Fixme
        /*if(!this.listeningToResize){
            this.listeningToResize = true;
            $(window).on('resize',this.onWindowResize.bind(this));
        }*/

        this.onWindowResize();

        $('#loginBtn').click(this.onClick.bind(this));

        this.mfaChallenge = null;
        this.pendingMfaResponse = null;
        this.originalLoginButtonLabel = undefined;
        let codeLabel = this.getMfaText('MFA_CODE_LABEL');
        this.$el.find('#login-mfa-code').attr('placeholder', codeLabel).attr('aria-label', codeLabel);
        this.$el.find('#login-mfa-qrcode').attr('alt', this.getMfaText('MFA_QRCODE_ALT'));
        this.$el.find('#login-mfa-cancel').text(this.getMfaText('MFA_CANCEL')).click((ev) => {
            ev.preventDefault();
            if(this.pendingMfaResponse !== null) {
                return;
            }
            this.resetMfa();
            this.$el.find('#login-mail').focus();
        });
        this.$el.find('#login-mfa-resend').click(() => this.sendMfaReply('RESEND'));
        this.$el.find('#login-mfa-code').on('input', () => this.invalidLabel.hide());
    }

    /**
     * There are two images that are displayed in the login background. One is
     * optimized for portrait, the other one for landscape orientation. Based on
     * the screen resolution, this handler will change the url to the other
     * orientation background if it's not already the right one.
     */
    onWindowResize(){
        let w = $(window).width();
        let h = $(window).height();

        var curOr = w > h ? 'landscape' : 'portrait';
        if(this.currentOrientation !== curOr){
            this.currentOrientation = curOr;
            //orientation change, we reload the background image
            this.background.css('background-image', 'url('+Server.getTokenedUrl('app/login/webbackground_'+this.currentOrientation+'.jpg')+')');
        }
    }

    /**
     * This function is called when the user clicks on the login button. It'll
     * call the server and handle the success/failure result.
     *
     * @param {*} ev The click event
     */
    onClick (ev) {
        if(this.mfaChallenge !== null) {
            this.sendMfaReply('VALIDATE');
            return;
        }
        let newPassword = $('#login-update-password').val();
        if(newPassword !== undefined && newPassword !== '') {
            this.executeUpdate();
        } else {
            this.invalidLabel.hide();
            let id = $('#login-mail').val().trim();
            let pwd = $('#login-password').val();
            if(id === null || id.length === 0 || pwd === null || pwd.length === 0) {
                this.onLoginError({
                    code : 'INVALID_INPUT',
                    body : 'Le nom d\'utilisateur et le mot de passe ne doivent pas être vides.'
                });
                return;
            }
            let loginMessage = new LoginRequest(id, $('#login-password').val(), null);
            let loadingReqId;
            LoadingMask.requestLoading('Login en cours')
                .then((reqId) => {
                    loadingReqId = reqId;
                    return Server.performRequest(loginMessage);
                })
                .then(this.onLoginSuccess.bind(this, id))
                .catch(this.onLoginError.bind(this))
                .finally(() => { LoadingMask.hide(loadingReqId); });
        }
    }

    tokenConnect() {
        let loginMessage = new LoginRequest(null,null, JSON.parse(sessionStorage.saiUserToken));
        let loadingReqId;
        LoadingMask.requestLoading('Login en cours')
            .then((reqId) => {
                loadingReqId = reqId;
                return Server.performRequest(loginMessage);
            })
            .then(this.onLoginSuccess.bind(this, sessionStorage.saiUserId))
            .catch(this.onLoginError.bind(this))
            .finally(() => { LoadingMask.hide(loadingReqId); });
    }

    /**
     * This function is called upon credential authentication success. It'll
     * preload a lot of structure before moving on to the application desktop
     * or the requested url
     *
     * @param {*} user The currently authenticating user
     * @param {*} response The server response that contains properties and
     * session information for the user
     */
    onLoginSuccess (user, response) {
        this.resetMfa();
        User.setId(user);
        this.initializeSession(user, response);
        sessionStorage.saiUserToken = JSON.stringify(response.token);
        sessionStorage.saiUserId = user;
        return new Promise((success,error) => {
             Promise.all([ThemeManager.getUserTheme()])
            .then(() => {
                if (this.loginPath) {
                    App.router.navigate('#' + this.loginPath, {trigger: true});
                } else {
                    App.router.navigate('#desktop', {trigger: true});
                }
                AlertManager.reset();
                success(undefined);
            })
            .catch((reason) => {
                this.onLoginError({message : 'Error while loading application, ' + reason + '. If it persists contact your administrator'});
                error();
            });
        });
    }

    /**
     * Initializes all the internal structures (User, Server, etc..) that will
     * allow the user to use the application, based on the server successful reply
     *
     * @param {*} user The currently authenticating user
     * @param {*} response The server response that contains properties and
     */
    initializeSession(user, response) {
        //Session token that will allow to make authenticated calls
        Server.setToken(response.token);
        //User id
        User.setId(user);
        User.setAvailableTasks(response.availableTasks);
        //User working domain
        User.setAvailableDomains(response.availableDomains);
        let baseDomain = response.currentDomain;
        if(User.getCurrentDomain() === undefined) {
            User.setCurrentDomain(baseDomain);
        } else {
            baseDomain = User.getCurrentDomain();
        }

        //User config properties (behaviors, menus, etc..)
        User.setProperties(response.properties, baseDomain);
        //User session language
        User.setLocale(response.locale);
        moment.locale(User.getLocale());
        //User configuration package context
        DomainManager.setContext(baseDomain, new DomainContext(baseDomain, response.currentConfiguration));
        //Cleaning local storage from old parametrage if any
        this.cleanupStorage(response.currentConfiguration);

        App.getAvailableExercices(DomainManager.getContext(baseDomain))
            .then((exercices) => {
                for(let i in exercices as any) {
                    let exercice = exercices[i];
                    if(exercice.active) {
                        DomainManager.getContext(baseDomain).setExercice(exercice);
                        break;
                    }
                }
            });
    }

    /**
     * Cleanup the local storage to remove old configuration entries
     * @param configId the name of the package
     */
    cleanupStorage(configId: string) {
        if (typeof (Storage) !== undefined) {
            for (var i = 0; i < localStorage.length; i++) {
                let item = localStorage.key(i);
                if ((item.indexOf(configId) <= 0 && item.indexOf('configuration') === 0) || item.indexOf(Config.serverUrl) == 0) {
                    localStorage.removeItem(item);
                }
            }
        }
    }

    /**
     * This function visually display an error on the login panel. It's called when
     * something wrong happens with the application login
     * @param { message: string } response The response to display on the login
     * as login error
     */
    onLoginError (response) {
        if(MfaUtils.isMfaChallenge(response)) {
            this.onMfaChallenge(response);
            return;
        }
        let errorText = response !== undefined ? response.body : undefined;
        if(MfaUtils.isMfaExpired(response)) {
            this.resetMfa();
            errorText = MfaUtils.formatServerText(errorText);
        }
        if(response !== undefined) {
            this.shakeForm();
            this.invalidLabel.show();
            this.invalidLabel.text(errorText);

            if(response.code === 'SYSTEM_PASSWORD_EXPIRED') {
                $('.update-password').show();
                $('#loginBtn').text('Mettre à jour');
            }
        }
    }

    private shakeForm() {
        this.mainFrame.css('webkitAnimationName', 'tada');
        this.mainFrame.css('animationName', 'tada');
    }

    private getMfaText(textId : string) : string {
        let language = (User.getLocale() || 'fr').substring(0, 2).toLowerCase();
        return I18NUtils.getText(textId, language, {});
    }

    private sendMfaReply(mfaResponse : 'VALIDATE' | 'RESEND') {
        let code = '';
        if(mfaResponse === MfaUtils.BUTTON_VALIDATE) {
            code = MfaUtils.normalizeCode(this.$el.find('#login-mfa-code').val() as string, this.isEmailChallenge());
            if(code.length === 0) {
                this.shakeForm();
                this.invalidLabel.text(this.getMfaText('MFA_CODE_EMPTY')).show();
                return;
            }
        }
        this.pendingMfaResponse = mfaResponse;
        let requestId = ++this.mfaRequestId;
        this.invalidLabel.hide();
        this.$el.find('#login-mfa-info').hide();

        let userId = (this.$el.find('#login-mail').val() as string).trim();
        let loginMessage = new LoginRequest(userId, this.$el.find('#login-password').val(), null);
        loginMessage.setMfaReply({
            message : this.mfaChallenge.code,
            screen : this.mfaChallenge.screenId,
            response : mfaResponse,
            code : code
        });
        let loadingReqId;
        this.setMfaBusy(true);
        LoadingMask.requestLoading('Login en cours')
            .then((reqId) => {
                loadingReqId = reqId;
                return Server.performRequest(loginMessage);
            })
            .then((response) => requestId === this.mfaRequestId ? this.onLoginSuccess(userId, response) : undefined)
            .catch((error) => {
                if(requestId === this.mfaRequestId) {
                    this.onLoginError(error);
                }
            })
            .finally(() => {
                LoadingMask.hide(loadingReqId);
                if(requestId !== this.mfaRequestId) {
                    return;
                }
                this.pendingMfaResponse = null;
                this.setMfaBusy(false);
                if(this.mfaChallenge !== null) {
                    this.$el.find('#login-mfa-code').focus();
                }
            });
    }

    private setMfaBusy(busy : boolean) {
        this.$el.find('#login-mfa-resend').prop('disabled', busy);
        this.$el.find('#loginBtn').prop('disabled', busy);
        this.$el.find('#login-mfa-cancel').toggleClass('disabled', busy).attr('aria-disabled', busy ? 'true' : 'false');
    }

    private isEmailChallenge() : boolean {
        return this.mfaChallenge !== null && this.mfaChallenge.code === MfaUtils.CODE_EMAIL;
    }

    private onMfaChallenge(message : MfaMessage) {
        let alreadyInMfa = this.mfaChallenge !== null;
        let codeScreen = MfaUtils.getCodeScreen(message);
        this.mfaChallenge = { code : message.code, screenId : MfaUtils.getCodeScreenId(message) };
        this.$el.find('#login-mfa-code').attr('inputmode', MfaUtils.isEmailChallenge(message) ? 'text' : 'numeric');

        this.$el.find('#login-mail, #login-password').prop('disabled', true);
        this.$el.find('.login-mfa, .login-mfa-actions').show();
        this.$el.find('#login-mfa-message').text(MfaUtils.formatServerText(message.body));
        this.displayMfaQrCode(codeScreen ? MfaUtils.getField(codeScreen, MfaUtils.FIELD_QRCODE) : undefined);
        this.displayMfaResendButton(message);

        let loginButton = this.$el.find('#loginBtn');
        if(!alreadyInMfa) {
            this.originalLoginButtonLabel = loginButton.text();
        }
        loginButton.text(this.getMfaText('MFA_VALIDATE_BUTTON'));

        let info = this.$el.find('#login-mfa-info');
        this.$el.find('#login-mfa-code').val('');
        if(alreadyInMfa && this.pendingMfaResponse === MfaUtils.BUTTON_RESEND) {
            this.invalidLabel.hide();
            info.text(this.getMfaText('MFA_CODE_RESENT')).show();
        } else if(alreadyInMfa) {
            info.hide();
            this.shakeForm();
            this.invalidLabel.text(this.getMfaText('MFA_CODE_INVALID')).show();
        }
        this.$el.find('#login-mfa-code').focus();
    }

    private displayMfaQrCode(qrCodeField : { imageSource? : string } | undefined) {
        let qrCode = this.$el.find('#login-mfa-qrcode');
        let bitmap = qrCodeField ? MfaUtils.parseBitmap(qrCodeField.imageSource) : null;
        if(bitmap === null) {
            qrCode.hide();
            return;
        }
        let moduleSize = Math.max(3, Math.floor(180 / (Math.max(bitmap.width, bitmap.height) + 8)));
        let dataUrl = MfaUtils.renderQrCode(bitmap, moduleSize);
        if(dataUrl === null) {
            qrCode.hide();
            return;
        }
        qrCode.attr('src', dataUrl).attr('data-modules', bitmap.width).show();
    }

    private displayMfaResendButton(message : MfaMessage) {
        let resendButton = this.$el.find('#login-mfa-resend');
        let resend = MfaUtils.getButton(message, MfaUtils.BUTTON_RESEND);
        if(resend === undefined) {
            resendButton.hide();
            return;
        }
        let lines = MfaUtils.splitLabel(resend.label);
        resendButton.text(lines[0]).attr('title', lines.join(' - ')).show();
    }

    private resetMfa() {
        this.mfaChallenge = null;
        this.pendingMfaResponse = null;
        this.mfaRequestId++;
        this.$el.find('#login-mail, #login-password').prop('disabled', false);
        this.$el.find('.login-mfa, .login-mfa-actions, #login-mfa-qrcode, #login-mfa-resend, #login-mfa-info').hide();
        this.$el.find('#login-mfa-code').val('');
        this.invalidLabel.hide();
        this.setMfaBusy(false);
        if(this.originalLoginButtonLabel !== undefined) {
            this.$el.find('#loginBtn').text(this.originalLoginButtonLabel);
            this.originalLoginButtonLabel = undefined;
        }
    }

    executeUpdate() {
        $('.invaliduserpass').hide();
        let username = this.$el.find('#login-mail').val() as string;
        username = username.trim();
        let currentPassword = this.$el.find('#login-password').val() as string;
        let newPassword = this.$el.find('#login-update-password').val() as string;
        let newPasswordConfirmation = this.$el.find('#login-update-password-confirmation').val() as string;

        if(newPassword === newPasswordConfirmation && newPassword !== '') {
            let request = new PasswordUpdateRequest(username, currentPassword, newPassword);

            let loadingReqId: string;
            LoadingMask.requestLoading('Mise à jour du mot de passe')
            .then((reqId) => {
                loadingReqId = reqId;
                Server.performRequest(request)
                .then(() => {
                    // The password update was successful, perform a login with the new password
                    let loginMessage = new LoginRequest(username, newPassword, null);
                    let loadingReqId;
                    LoadingMask.requestLoading('Login en cours')
                        .then((reqId) => {
                            loadingReqId = reqId;
                            return Server.performRequest(loginMessage);
                        })
                        .then(this.onLoginSuccess.bind(this, username))
                        .catch(this.onLoginError.bind(this))
                        .finally(() => { LoadingMask.hide(loadingReqId); });
                })
                .catch(this.onLoginError.bind(this))
            })
            .catch((error) => {
                App.displayErrorMessage(error);
            })
            .finally(() => {
                LoadingMask.hide(loadingReqId);
            });
        } else {
            if(newPassword === '') {
                $('.invaliduserpass').text('Le mot de passe ne doit pas être vide');
            } else {
                $('.invaliduserpass').text('Le mot de passe et la confirmation ne correspondent pas');
            }
            $('.invaliduserpass').show();
        }
    }
}

export default Login;
